import useAccessToken from 'hooks/useAccessToken';

import { FEATURE_MAP } from './constants';
import type { AvailableFeatures, FeatureFlag } from './types';

const useFeatureAccess = () => {
    const { decodedToken } = useAccessToken();

    const featureAccess = (
        Object.entries(FEATURE_MAP) as [FeatureFlag, AvailableFeatures][]
    ).reduce<Record<AvailableFeatures, boolean>>(
        (accessMap, [featureFlag, availableFeature]) => {
            const hasFeature =
                (decodedToken?.features as string[] | undefined)?.includes(featureFlag) ?? false;

            accessMap[availableFeature] = hasFeature;

            return accessMap;
        },
        {} as Record<AvailableFeatures, boolean>
    );

    return featureAccess;
};

export default useFeatureAccess;
